module.exports = __webpack_public_path__ + "img/search-find.1a59e558.svg";